(()=>{'use strict';
const config=JSON.parse(document.getElementById('kuma-config').textContent),m=config.messages;
const root=document.documentElement,nav=document.getElementById('kuma-navigation'),menu=document.querySelector('.menu-toggle'),showcase=document.querySelector('.hero-showcase');
const reduced=matchMedia('(prefers-reduced-motion: reduce)');
function updateMotion(){if(showcase)showcase.dataset.playing=String(canPlay());}
function closeMenu(){nav?.classList.remove('is-open');menu?.setAttribute('aria-expanded','false');menu?.setAttribute('aria-label',m.menuOpen)}
menu?.addEventListener('click',()=>{const open=!nav.classList.contains('is-open');nav.classList.toggle('is-open',open);menu.setAttribute('aria-expanded',String(open));menu.setAttribute('aria-label',open?m.menuClose:m.menuOpen)});
nav?.addEventListener('click',e=>{if(e.target.closest('a'))closeMenu()});document.addEventListener('keydown',e=>{if(e.key==='Escape'&&nav?.classList.contains('is-open')){closeMenu();menu?.focus()}});
const slides=[...document.querySelectorAll('.project-slide')],selectors=[...document.querySelectorAll('.slide-selectors button')];let active=0,hovered=false,focused=false,visible=false;
function canPlay(){return !reduced.matches&&!document.hidden&&!hovered&&!focused&&visible&&!document.querySelector('dialog[open]')}
function showSlide(index){if(!slides.length)return;active=(index+slides.length)%slides.length;slides.forEach((slide,i)=>{const current=i===active;slide.setAttribute('aria-hidden',String(!current));slide.inert=!current;slide.querySelectorAll('a,button').forEach(b=>b.tabIndex=current?0:-1)});selectors.forEach((b,i)=>{if(i===active)b.setAttribute('aria-current','true');else b.removeAttribute('aria-current');b.firstElementChild.classList.toggle('is-current',i===active);b.firstElementChild.replaceChildren();if(i===active)b.firstElementChild.append(document.createElement('i'))});showcase.dataset.slide=String(active+1);const indexEl=showcase.querySelector('.showcase-index');indexEl.firstChild.textContent='0'+(active+1);const top=showcase.querySelector('.showcase-topline span');top.textContent=top.textContent.replace(/0[1-3]$/,'0'+(active+1));updateMotion()}
selectors.forEach((b,i)=>b.addEventListener('click',()=>showSlide(i)));document.querySelector('.showcase-next')?.addEventListener('click',()=>showSlide(active+1));
if(showcase){showcase.addEventListener('mouseenter',()=>{hovered=true;updateMotion()});showcase.addEventListener('mouseleave',()=>{hovered=false;updateMotion()});showcase.addEventListener('focusin',()=>{focused=true;updateMotion()});showcase.addEventListener('focusout',e=>{if(!showcase.contains(e.relatedTarget)){focused=false;updateMotion()}});new IntersectionObserver(([e])=>{visible=e.isIntersecting;updateMotion()},{threshold:.3}).observe(showcase);let touchX=0;showcase.addEventListener('touchstart',e=>{touchX=e.touches[0].clientX},{passive:true});showcase.addEventListener('touchend',e=>{const delta=e.changedTouches[0].clientX-touchX;if(Math.abs(delta)>60)showSlide(active+(delta<0?1:-1))},{passive:true});setInterval(()=>{if(canPlay())showSlide(active+1)},6500)}
reduced.addEventListener('change',updateMotion);document.addEventListener('visibilitychange',updateMotion);updateMotion();
function syncHash(){const aliases={price:'pricing',skills:'services',DirectorFlow:'process','case-studies':'works',agencies:'service-partner'};let id=location.hash.slice(1);try{id=decodeURIComponent(id)}catch{}const alias=aliases[id];if(alias)id=alias;const target=document.getElementById(id);if(target?.tagName==='DETAILS')target.open=true;else if(id==='line-support')document.getElementById('service-line-support')?.setAttribute('open','');if(alias)target?.scrollIntoView({behavior:'instant'})}
addEventListener('hashchange',syncHash);syncHash();
document.addEventListener('click',e=>{const a=e.target.closest('a[href^="#service-"]');if(a){const d=document.querySelector(a.getAttribute('href'));if(d)d.open=true}});
const observer=new IntersectionObserver(entries=>entries.forEach(e=>{if(e.isIntersecting){e.target.classList.add('in-view');observer.unobserve(e.target)}}),{threshold:.08});document.querySelectorAll('[data-reveal],.work-image,.small-work-image,.system-diagram,.process ol').forEach(e=>observer.observe(e));
let scheduled=false;function progress(){scheduled=false;const h=root.scrollHeight-innerHeight;root.style.setProperty('--read-progress',String(h>0?scrollY/h:0));const c=document.getElementById('contact')?.getBoundingClientRect();root.dataset.consult=scrollY>650&&(!c||c.top>innerHeight||c.bottom<0)?'visible':'hidden'}function onScroll(){if(!scheduled){scheduled=true;requestAnimationFrame(progress)}}addEventListener('scroll',onScroll,{passive:true});addEventListener('resize',onScroll);progress();
const type=document.getElementById('inquiry-type'),body=document.getElementById('inquiry-body');if(type&&body){const q=new URLSearchParams(location.search);let requested=q.get('type')||q.get('inquiry_item');if(requested==='LINE連携・導線づくり')requested='LINE公式アカウント構築';if(requested==='ECサイト構築')requested='Shopify構築・改修';if(requested==='制作会社さまとの協業')requested='制作会社さまからの実装依頼';if(config.inquiryTypes.includes(requested))type.value=requested;const project=q.get('project');if(project&&!body.value)body.value=(m.projectIntro+project.slice(0,180)+m.projectPrompt).slice(0,1800);document.querySelector('.kuma-form-status')?.focus();}
})();

(()=>{'use strict';
document.querySelectorAll('.catalog-image img,.work-image img,.small-work-image img,.project-visual img,.case-detail-image').forEach(image=>{
  const container=image.closest('.catalog-image,.work-image,.small-work-image,.project-visual')||image;
  const loaded=()=>container.classList.add('is-loaded');
  if(image.complete&&image.naturalWidth)loaded();else image.addEventListener('load',loaded,{once:true});
});
})();

(()=>{'use strict';
const items=[...document.querySelectorAll('.faq-list details')],reduced=matchMedia('(prefers-reduced-motion: reduce)');
items.forEach(item=>{
  const trigger=item.querySelector(':scope > summary'),content=item.querySelector(':scope > .faq-content');
  if(!trigger||!content)return;
  let animation=null;
  const finish=open=>{
    const finished=animation;
    animation=null;
    item.open=open;
    item.classList.remove('is-opening','is-closing');
    item.style.removeProperty('height');
    item.style.removeProperty('overflow');
    finished?.cancel();
  };
  const animate=open=>{
    const start=item.getBoundingClientRect().height;
    animation?.cancel();
    if(open)item.open=true;
    item.classList.toggle('is-opening',open);
    item.classList.toggle('is-closing',!open);
    if(reduced.matches){finish(open);return;}
    const style=getComputedStyle(item),border=parseFloat(style.borderTopWidth)+parseFloat(style.borderBottomWidth);
    const end=trigger.offsetHeight+(open?content.offsetHeight:0)+border;
    item.style.height=`${start}px`;
    item.style.overflow='hidden';
    animation=item.animate({height:[`${start}px`,`${end}px`]},{duration:open?580:440,easing:open?'cubic-bezier(.2,1.16,.32,1)':'cubic-bezier(.55,0,.2,1)',fill:'both'});
    animation.onfinish=()=>finish(open);
  };
  trigger.addEventListener('click',event=>{
    event.preventDefault();
    animate(!item.open||item.classList.contains('is-closing'));
  });
});
})();

(()=>{'use strict';
const showcase=document.querySelector('.hero-evidence');
if(!showcase)return;
const track=showcase.querySelector('.evidence-track'),controls=showcase.querySelector('.evidence-controls');
if(!track||!controls)return;
const cards=[...track.querySelectorAll('.evidence-card')],categoryTabs=[...showcase.querySelectorAll('[data-evidence-category-tab]')],previous=controls.querySelector('[data-evidence-previous]'),next=controls.querySelector('[data-evidence-next]'),position=controls.querySelector('[data-evidence-current]'),total=controls.querySelector('[data-evidence-total]'),reduced=matchMedia('(prefers-reduced-motion: reduce)');
let visibleCards=cards,scheduled=false;
// 絞り込み後も、表示中のカードの実座標から位置を求める。
const cardLeft=card=>card.getBoundingClientRect().left-track.getBoundingClientRect().left+track.scrollLeft;
function currentIndex(){return visibleCards.reduce((best,card,index)=>Math.abs(cardLeft(card)-track.scrollLeft)<Math.abs(cardLeft(visibleCards[best])-track.scrollLeft)?index:best,0)}
function update(){
  scheduled=false;
  const index=currentIndex(),overflow=track.scrollWidth>track.clientWidth+2;
  controls.hidden=!visibleCards.length;
  previous.disabled=!overflow||index===0;
  next.disabled=!overflow||index>=visibleCards.length-1;
  position.textContent=String(visibleCards.length?index+1:0).padStart(2,'0');
  if(total)total.textContent=String(visibleCards.length).padStart(2,'0');
}
function schedule(){if(!scheduled){scheduled=true;requestAnimationFrame(update)}}
function move(direction){
  const index=Math.max(0,Math.min(visibleCards.length-1,currentIndex()+direction));
  if(visibleCards[index])track.scrollTo({left:cardLeft(visibleCards[index]),behavior:reduced.matches?'instant':'smooth'});
}
previous.addEventListener('click',()=>move(-1));next.addEventListener('click',()=>move(1));
categoryTabs.forEach(tab=>tab.addEventListener('click',()=>{
  const category=tab.dataset.evidenceCategoryTab;
  // 進行中のスクロールを止めてから、非該当カードを表示・フォーカス対象から外す。
  track.scrollTo({left:0,behavior:'instant'});
  cards.forEach(card=>{card.hidden=category!=='all'&&card.dataset.evidenceCategory!==category});
  visibleCards=cards.filter(card=>!card.hidden);
  categoryTabs.forEach(button=>button.setAttribute('aria-pressed',String(button===tab)));
  track.scrollTo({left:0,behavior:'instant'});
  update();
}));
track.addEventListener('scroll',schedule,{passive:true});
track.addEventListener('keydown',event=>{
  if(event.target!==track||!['ArrowLeft','ArrowRight','Home','End'].includes(event.key))return;
  event.preventDefault();
  move(event.key==='Home'?-visibleCards.length:event.key==='End'?visibleCards.length:event.key==='ArrowRight'?1:-1);
});
new ResizeObserver(schedule).observe(track);schedule();
})();

(()=>{'use strict';
// Event payloads contain only public route IDs and allowlisted choice values.
const config=JSON.parse(document.getElementById('kuma-config').textContent);
const inquiry=value=>config.inquiryTypes.includes(value)?value:'';
const queue=[];let timer;
function flush(){
  if(!window.Shopify?.analytics?.publish){
    while(queue.length&&Date.now()-queue[0].createdAt>20000)queue.shift().resolve(false);
    if(queue.length)timer=setTimeout(flush,100);
    return;
  }
  while(queue.length){
    const item=queue.shift();
    try{Promise.resolve(window.Shopify.analytics.publish('kuma_code:'+item.name,item.data)).then(result=>item.resolve(result!==false),()=>item.resolve(false))}catch{item.resolve(false)}
  }
}
const publish=(name,data={})=>new Promise(resolve=>{queue.push({name,data:{...data},createdAt:Date.now(),resolve});clearTimeout(timer);flush()});
const placement=element=>{if(element.closest('.contact-page'))return'contact_page';if(element.closest('.page-consult'))return'case_page';if(element.closest('.blog-consult'))return'blog';if(element.closest('dialog.case-dialog'))return'case_dialog';if(element.closest('#contact'))return'home_contact';if(element.closest('.hero'))return'hero';if(element.closest('header'))return'header';if(element.closest('footer'))return'footer';if(element.closest('#services'))return'services';if(element.closest('.mobile-consult'))return'mobile_contact';return'other'};
const caseEntry=Object.entries(config.caseRoutes).find(([,path])=>path===location.pathname.replace(/\/$/,''));
if(caseEntry)publish('view_case',{case_slug:caseEntry[0]});
const serviceAccordions=[...document.querySelectorAll('details[id^="service-"]')];
serviceAccordions.forEach(service=>{
  const track=()=>publish('view_service',{service_id:service.id.replace('service-',''),inquiry_type:inquiry(service.dataset.inquiry)});
  // Hash navigation may have opened the accordion before listeners were attached.
  if(service.open)track();
  let lastOpen=service.open;
  service.addEventListener('toggle',()=>{const opened=service.open&&!lastOpen;lastOpen=service.open;if(!opened)return;serviceAccordions.forEach(other=>{if(other!==service)other.removeAttribute('open')});track()});
});
document.addEventListener('click',event=>{
  const link=event.target.closest('a[href]');if(!link)return;
  let url;try{url=new URL(link.href,location.origin)}catch{return}
  const pending=[];
  if(url.origin===location.origin){
    const entry=Object.entries(config.caseRoutes).find(([,path])=>path===url.pathname.replace(/\/$/,''));
    if(entry)pending.push(publish('select_case',{case_slug:entry[0],placement:placement(link)}));
    if(url.pathname==='/pages/contact'||(url.pathname===location.pathname&&url.hash==='#contact')){
      pending.push(publish('begin_contact',{placement:placement(link),inquiry_type:inquiry(url.searchParams.get('type')||link.closest('details')?.dataset.inquiry)}));
    }
  }
  if(url.hostname==='lin.ee'||url.hostname==='line.me')publish('click_line_contact',{placement:placement(link),inquiry_type:inquiry(document.getElementById('inquiry-type')?.value)});
  if(url.protocol==='mailto:')publish('click_email_contact',{placement:placement(link)});
  // Give Shopify's event bus a short opportunity before same-tab navigation.
  if(pending.length&&url.pathname!==location.pathname&&!event.defaultPrevented&&event.button===0&&!event.metaKey&&!event.ctrlKey&&!event.shiftKey&&!event.altKey&&(!link.target||link.target==='_self')&&!link.hasAttribute('download')){
    event.preventDefault();Promise.race([Promise.all(pending),new Promise(resolve=>setTimeout(resolve,300))]).then(()=>location.assign(link.href));
  }
});
const type=document.getElementById('inquiry-type');
type?.addEventListener('change',()=>publish('select_inquiry_type',{inquiry_type:inquiry(type.value)}));
const storageKey='kuma-contact-submit';
const contactForm=document.getElementById('ContactForm');
if(contactForm){
  let started=false;
  contactForm.addEventListener('focusin',()=>{if(started)return;started=true;publish('begin_contact_form',{inquiry_type:inquiry(type?.value)})});
  contactForm.addEventListener('submit',()=>{try{sessionStorage.setItem(storageKey,JSON.stringify({createdAt:Date.now(),inquiryType:inquiry(type?.value)}))}catch{}});
}
if(document.querySelector('.kuma-form-status[role="alert"]')){try{sessionStorage.removeItem(storageKey)}catch{}}
const success=document.querySelector('.kuma-form-status[role="status"]');
if(success){
  try{
    const raw=sessionStorage.getItem(storageKey);
    if(raw){
      const submission=JSON.parse(raw),age=Date.now()-submission.createdAt;
      if(Number.isFinite(age)&&age>=0&&age<600000){publish('submit_contact',{inquiry_type:inquiry(submission.inquiryType)}).then(sent=>{if(sent){try{sessionStorage.removeItem(storageKey)}catch{}}})}
      else sessionStorage.removeItem(storageKey);
    }
  }catch{}
}
let scrolled=false;
addEventListener('scroll',()=>{if(scrolled)return;const height=document.documentElement.scrollHeight;if(height>innerHeight&&(scrollY+innerHeight)/height>=.9){scrolled=true;publish('scroll')}},{passive:true});
})();

(()=>{'use strict';
const selector='.portfolio main p,.portfolio main li,.portfolio main h1,.portfolio main h2,.portfolio main h3,.portfolio main h4,.evidence-card-description';
const excluded='button,summary,nav,form,label,.breadcrumbs,.tags,.hero-actions,.hero-browse,.work-group-nav,.home-work-tab-list';
const breakAttribute='data-kuma-punctuation-break';
const range=document.createRange();
const textWalker=element=>{
  const walker=document.createTreeWalker(element,NodeFilter.SHOW_TEXT,{acceptNode(node){
    if(!node.data||!node.data.trim())return NodeFilter.FILTER_REJECT;
    const parent=node.parentElement;
    if(!parent||parent.closest('[aria-hidden="true"],script,style'))return NodeFilter.FILTER_REJECT;
    return NodeFilter.FILTER_ACCEPT;
  }}),characters=[];
  let node;
  while((node=walker.nextNode()))for(let offset=0;offset<node.data.length;offset++)characters.push({node,offset,char:node.data[offset]});
  return characters;
};
const characterRect=entry=>{
  range.setStart(entry.node,entry.offset);
  range.setEnd(entry.node,entry.offset+1);
  return range.getBoundingClientRect();
};
function removeGeneratedBreaks(){
  document.querySelectorAll(`br[${breakAttribute}]`).forEach(br=>{const parent=br.parentNode;br.remove();parent?.normalize()});
}
function applyBreak(element){
  if(element.closest(excluded)||element.closest('details:not([open])')||element.querySelector('a,button,input,select,textarea,details,summary'))return false;
  const characters=textWalker(element);
  if(characters.length<12)return false;
  const box=element.getBoundingClientRect(),style=getComputedStyle(element);
  const left=box.left+parseFloat(style.paddingLeft||0),width=element.clientWidth-parseFloat(style.paddingLeft||0)-parseFloat(style.paddingRight||0);
  if(width<=0)return false;
  for(let index=0;index<characters.length;index++){
    const current=characters[index];
    if(current.char!=='、'&&current.char!=='。')continue;
    let next=index+1;
    while(next<characters.length&&/\s/.test(characters[next].char))next++;
    if(next>=characters.length)continue;
    const punctuationRect=characterRect(current),nextRect=characterRect(characters[next]);
    const sameLine=Math.abs(punctuationRect.top-nextRect.top)<2;
    const progress=(punctuationRect.right-left)/width;
    if(!sameLine||progress<.8)continue;
    const tail=current.node.splitText(current.offset+1),br=document.createElement('br');
    br.setAttribute(breakAttribute,'');
    current.node.parentNode.insertBefore(br,tail);
    return true;
  }
  return false;
}
function formatPunctuation(){
  removeGeneratedBreaks();
  document.querySelectorAll(selector).forEach(element=>{
    let passes=0;
    while(passes<8&&applyBreak(element))passes++;
  });
}
let timer;
function schedulePunctuation(){clearTimeout(timer);timer=setTimeout(formatPunctuation,120)}
formatPunctuation();
document.fonts?.ready.then(formatPunctuation);
addEventListener('resize',schedulePunctuation,{passive:true});
document.addEventListener('toggle',event=>{if(event.target.matches('details')&&event.target.open)schedulePunctuation()},true);
})();
